'use client';
import { useEffect, useRef } from 'react';
import { ensureRampQueue } from '@/features/ads/shared/helper/playwire-runtime';

type RampLoaderProps = {
  pubId: string;
  websiteId: string;
};

export const RampLoader = ({ pubId, websiteId }: RampLoaderProps) => {
  const loadedRef = useRef(false);

  useEffect(() => {
    if (!pubId || !websiteId) {
      console.log('Missing Publisher Id and Website Id');
      return;
    }

    if (loadedRef.current) {
      return;
    }

    const ramp = ensureRampQueue();
    ramp.passiveMode = true;
    const configScript = document.createElement('script');
    configScript.src = `https://cdn.intergient.com/${pubId}/${websiteId}/ramp.js`;
    document.body.appendChild(configScript);
    loadedRef.current = true;
  }, [pubId, websiteId]);

  return null;
};
